import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import redOldGlory from 'assets/redOldGlory.png';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
export default function Header() {
    const userInfo = useSelector((state: RootState) => state.user?.userInfo);
    const { businessName, nickname } = userInfo || {};

    return (
        <div
            style={{
                backgroundImage: `url(${redOldGlory})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '1vh',
                borderRadius: 6,
                height: '150px',
            }}
        >
            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                <Typography sx={{ fontSize: 32 }} color={'white'} variant="h6">
                    {businessName}
                </Typography>
                <Typography sx={{ fontSize: 25 }} color={'white'} variant="h6">
                    {dayjs().format('MMMM, DD, YYYY')}
                </Typography>
            </Stack>
            <Typography sx={{ fontSize: 18 }} color={'white'} variant="h5">
                {nickname}
            </Typography>
        </div>
    );
}
